<template>
  <header class="buheader" :class="{ 'buheader__grey': surrounding.id === 1772 }">
    <div class="buheader-top d-flex position-relative justify-content-between mx-4" >
      <div class="buheader-top__toggle toggle d-block d-md-none py-5" @click="$emit('toggle')">
        <span class="icon-bar d-block mt-2"></span>
        <span class="icon-bar d-block"></span>
        <span class="icon-bar d-block"></span>
      </div>
      <div class="buheader-top__branding d-flex align-items-end position-absolute p-0 py-4 p-md-3 w-100" :class="{ 'justify-content-center': surrounding.id !== 1772 || $mq === 'sm' }" to="/">
        <router-link to="/" class="d-block">
          <img
            :src="surrounding.logo"
            :alt="surrounding.name"
          />
        </router-link>
        <span v-if="surrounding.id === 1772" class="d-none d-md-block font-patrick-hand buheader-top__slogan">STOER EN EIGENTIJDS!</span>
      </div>
      <div class="d-none d-md-flex position-relative ml-auto py-5">
        <ec-business-social
          :facebook="surrounding.facebook"
          :instagram="surrounding.instagram"
          :phonenumber="surrounding.phonenumber"
          :twitter="surrounding.twitter"
          :id="surrounding.id"
          class="buheader-top__social"
        />
      </div>
      <div class="d-md-none ml-auto py-5 buheader-top__social">
        <div class="buheader-top__social-enjoj px-2">
          <a :href="'https://beta.enjoj-test.nl/community/surrounding/' + surrounding.id">
            <span>
              <img src="@/assets/images/enjoj-logo.png" alt="ENJOJ">
            </span>
          </a>
        </div>
      </div>
    </div>
    <slot name="menu" />
  </header>
</template>

<script>
import ecBusinessSocial from '@/components/Business/components/General/Template/Navigation/Social'
import Utilities from '@/mixins/Utilities'

export default {
  name: 'ec-business-header',
  components: {
    ecBusinessSocial
  },
  mixins: [Utilities],
  props: {
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
